<template>
    <!-- 
        Not using `download` attribute here becuase the download does not happen immediately.
        The visitor might not know that anything is happening and might attempt to push the download button repeatedly.
    -->
    <a
        v-if="url"
        :href="url"
        target="_blank"
        rel="noopener noreferrer"
        class="mg-button mg-button--large mg-button--accent md-chart-wrapper__download no-print"
    >
        Download Data
    </a>
</template>
<script>
import { mapState } from "vuex";
export default {
    props: ["data-for"],
    name: "data-download-button",
    data() {
        return {
            paramString: ""
        };
    },
    computed: {
        ...mapState([
            "activeMarket",
            "selectedMarket",
            "marketDataMode",
            "top_exports_selected",
            "export_totals"
        ]),
        endpoint() {
            if (this.dataFor == "GIAF-chart") {
                if (this.isWorldTotal) {
                    return "/wp-content/mu-plugins/plugin-exportAllData/index.php";
                } else {
                    return "/wp-content/mu-plugins/plugin-exportCountryData/index.php";
                }
            } else if (this.dataFor == "top-exports-chart") {
                return "/wp-content/mu-plugins/plugin-exportCommodityData/index.php";
            }
        },
        url() {
            return this.endpoint + this.paramString;
        },
        isWorldTotal() {
            return this.selectedMarket === "World Total";
        }
    },
    watch: {
        activeMarket() {
            this.makeParamString();
        },
        marketDataMode() {
            this.makeParamString();
        },
        top_exports_selected() {
            this.makeParamString();
        }
    },
    methods: {
        makeParamString() {
            let params = [];

            if (this.dataFor == "GIAF-chart") {
                if (!this.activeMarket) return;

                if (!this.isWorldTotal) {
                    params.push(`countryCode=${this.activeMarket.market_code}`);
                }

                if (this.marketDataMode == "USDA-data") {
                    params.push("USDA=1");
                } else {
                    params.push("USDA=0");
                }
            } else if (this.dataFor == "top-exports-chart") {
                let commodityCode = this.top_exports_selected;

                if (this.top_exports_selected != "all" && this.export_totals) {
                    commodityCode =
                        this.export_totals[this.top_exports_selected]["code"];
                }

                params.push(`commodity_code=${commodityCode.toUpperCase()}`);
            }

            if (params.length) {
                this.paramString = `?${params.join("&")}`;
            }
        }
    },
    created() {
        this.makeParamString();
    }
};
</script>



// WEBPACK FOOTER //
// src/js/vue-components/data-download-button.vue